import * as React from "react";
import BaseComponent from "../../../utility/BaseComponent";
import { observable, action, runInAction } from "mobx";
import { ActivityLogItem } from "../../../utility/admin/UsersControls/UsersAnalytics/IUsersAnalytics";
import { IServicesProvider } from "../../../di/IServicesProvider";
import { observer } from "mobx-react";
import "./static/LatestActivityTable.scss";
import { CircularProgress } from "react-md";
import { IBaseModel } from "../../../utility/IBaseModel";
export class LatestActivityTableModel implements IBaseModel {
    
    @observable asyncOperationsCount: number = 0;

    @observable activityLog: ActivityLogItem[] = [];
    private servicesProvider: IServicesProvider;
    @action.bound
    incrementAsyncOperations() {
        this.asyncOperationsCount = this.asyncOperationsCount + 1;
    }
    @action.bound
    decrementAsyncOperations() {
        this.asyncOperationsCount = this.asyncOperationsCount - 1;
    }
    
    constructor(servicesProvider: IServicesProvider) {
        this.servicesProvider = servicesProvider;
    }

    @action prepare() {
        this.incrementAsyncOperations();
        this.servicesProvider.getAdminServicesProvider()
        .getUsersControls().getAnalytics()
        .subscribe( result => {
            if (this.asyncOperationsCount > 0) {
                this.decrementAsyncOperations();
            }
            runInAction( () => {
                this.activityLog = result.getActivityLog();        
            });
        });
        
    }
}
@observer class LatestActivityTable extends BaseComponent< {model: LatestActivityTableModel}, {}> {

    render() {
        return (
            <div className="LatestActivityTableContainer">
                <table>
                    <thead>
                        <tr>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                    
                    {   this.props.model.asyncOperationsCount === 0 &&
                        this.props.model.activityLog
                        .slice(0, 
                               this.props.model.activityLog.length > 10 ? 15 :
                                this.props.model.activityLog.length
                        )
                        .map( (item, index) => 
                            <tr key={index}>
                                <td>{item.date}</td>
                                <td>{item.time}</td>
                                <td>{item.description}</td>
                            </tr>
                        )
                    }
                    </tbody>
                </table>
                {
                    this.props.model.asyncOperationsCount !== 0 &&     
                    <CircularProgress centered={true} id="Progress" />
                }
            </div>
        );
    }
}
export default LatestActivityTable;


// WEBPACK FOOTER //
// ./src/view/Admin/LatestActivityTable/LatestActivityTable.tsx